import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Rating from "@mui/material/Rating";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getSupportCount, setParentCourse } from "../Action/courseAction";
import MenuIcon from "@mui/icons-material/Menu";

function PageTitle(Props) {
  const dispatch = useDispatch();
  const currentURLarr = useLocation().pathname;
  const [supportCount, setSupportCount] = useState({
    newIssue: 0,
    inProgress: 0,
    closed: 0,
  });

  useEffect(() => {
    if (Props?.isSupportCount) {
      dispatch(
        getSupportCount((res) => {
          setSupportCount(res);
          // dispatch(setParentCourse("teacherCoupon", res?.coupon));
        }),
      );
    }
  }, []);

  const onClick = () => {
    const url = "https://chat.openai.com/?model=gpt-4-turbo";
    const width = 1000;
    const height = 800;
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2;

    // open blank first and cut window.opener, so the third-party page can never
    // reach back into (or redirect) the admin tab — reverse tab-nabbing
    const popup = window.open(
      "",
      "ChatGPTPopup",
      `width=${width},height=${height},top=${top},left=${left},resizable,scrollbars=yes,status=1`,
    );

    // fallback if popup is blocked
    if (!popup || popup.closed || typeof popup.closed === "undefined") {
      window.location.href = url;
      return;
    }
    try {
      popup.opener = null;
    } catch (_) {
      /* re-used window already on chat.openai.com — it was opened without an opener */
    }
    popup.location.href = url;
  };

  return (
    <div className="page-title-wrapper d-flex align-items-center w-100">

  <h5 className="Title d-flex align-items-center w-100">

    {/* <button
      className="mobile-menu-btn"
      onClick={() =>
        dispatch(setParentCourse("isSidebarOpen", true))
      }
    >
      <MenuIcon className="menu-icon" />
    </button> */}

    <span>
      {Props.name?.toUpperCase()}
    </span>
        {currentURLarr === "/TeacherPanel/feedback" ||
        currentURLarr === "/TeacherPanel/lectureFeedback" ||
        currentURLarr === "/CXOPanel/teacherfeedback" ||
        currentURLarr === "/CXOPanel/teacherLectureFeedback" ? (
          <div className="d-flex justify-content-between">
            <span className="font-12 text-dark d-flex pt-3">
              overall rating:
            </span>
            <span className="d-flex font-12 pt-3" style={{ color: "#3F51B5" }}>
              {Props?.overallRating
                ? Math.round(
                    (parseFloat(Props?.overallRating) + Number.EPSILON) * 10,
                  ) / 10
                : "0"}
            </span>
            <span className="text-secondary pt-3 font-10 d-flex">
              ({Props?.reviewCount ? Props?.reviewCount : "0"})
            </span>
            <span className=" pt-2 ">
              <Box
                sx={{
                  "& > legend": { mt: 2 },
                }}
              >
                <Rating
                  name="simple-controlled size-small"
                  value={Props?.overallRating}
                />
              </Box>
            </span>
          </div>
        ) : null}
        {currentURLarr === "/TeacherPanel/chat" ? (
          <div className="d-flex justify-content-between">
            <button type="button" className="btn btn-primary" onClick={onClick}>
              {" "}
              🚀 Launch ChatGPT Plus{" "}
            </button>
          </div>
        ) : null}
        {Props?.isSupportCount ? (
          <div className="d-flex justify-content-between">
            {Props?.couponCode ? (
              <div className="position-relative">
                <div className="me-2">Coupon Code: {Props?.couponCode} </div>
              </div>
            ) : null}

            <div className="position-relative d-flex">
              <div className="btn-div">New Issue</div>
              <div className="number-div">{supportCount?.newIssue}</div>
            </div>
            <div className="position-relative d-flex">
              <div className="btn-div">In Progress</div>
              <div className="number-div">{supportCount?.inProgress}</div>
            </div>
            <div className="position-relative d-flex">
              <div className="btn-div">Resolved</div>
              <div className="number-div">{supportCount?.closed}</div>
            </div>
          </div>
        ) : null}
        {Props.isEditMode ? (
          <div>
            <button className="btn btn-outline-primary" onClick={Props.onClick}>
              {Props.btnName ? Props.btnName : "Cancel Edit"}
            </button>
          </div>
        ) : null}
        {Props.isGoBack ? (
          <div>
            <button className="btn btn-outline-primary" onClick={Props.onClick}>
              Go Back
            </button>
          </div>
        ) : null}
        {/* right side of the header, e.g. a Filters button (CustomPageLayout headerActions) */}
        {Props.actions ? <div className="page-title-actions ms-auto d-flex align-items-center gap-2">{Props.actions}</div> : null}
      </h5>
    </div>
  );
}

export default PageTitle;
